<template>
  <div class="mt-4 p-3 border rounded-4 bg-light">
    <h4 class="mb-3">Configuración EasyPos</h4>
    <div class="mb-3">
      <label for="organizationId" class="form-label">Organization ID:<span class="text-danger">*</span></label>
      <input
        id="organizationId"
        type="text"
        class="form-control"
        v-model="localOrganizationId"
        @input="onOrgIdChange"
        maxlength="100"
        placeholder="Ej: 12345" />
    </div>
    <div class="mb-3">
      <label for="puntoVentaId" class="form-label">Punto de Venta ID:<span class="text-danger">*</span></label>
      <input
        id="puntoVentaId"
        type="text"
        class="form-control"
        v-model="localPuntoVentaId"
        @input="onPuntoIdChange"
        maxlength="100"
        placeholder="Ej: 67890" />
    </div>
  </div>
</template>

<script>
    export default {
    name: 'FormEasyPosComponent',
    props: {
        organizationId: { type: String, default: '' },
        puntoVentaId: { type: String, default: '' }
    },
    data() {
        return {
            localOrganizationId: this.organizationId,
            localPuntoVentaId: this.puntoVentaId
        };
    },
    watch: {
        organizationId(val) {
            this.localOrganizationId = val;
        },
        puntoVentaId(val) {
            this.localPuntoVentaId = val;
        }
    },
    methods: {
        onOrgIdChange() {
            this.$emit('update:organizationId', this.localOrganizationId);
        },
        onPuntoIdChange() {
            this.$emit('update:puntoVentaId', this.localPuntoVentaId);
        }
    }
    };
</script>

<style scoped>

</style>
